import React from "react";
import InfoModal from "./InfoModal";

// Customer-facing message popup: centred icon, title, grey message, then the
// action buttons (pass <ModalButtonRow> / <ModalButton> as children).
//
// This is the layout of the booking-confirmation popup ("カートに追加しました");
// every customer popup that shows a message — confirmations, success notices —
// uses it so they all look the same.
//
// <MessageModal show onClose icon={<ChecklistIcon />} title="Saved" message="…">
//   <ModalButtonRow>…</ModalButtonRow>
// </MessageModal>

const ICON_COLOR = "#212529";
const ICON_SIZE = 20;

/**
 * @param {boolean} show
 * @param {Function} onClose - ✕, Escape and backdrop click
 * @param {Function} [icon] - icon component, e.g. ChecklistIcon; drawn 20px, dark
 * @param {React.ReactNode} [title]
 * @param {string} [titleHtml] - title containing markup from translations (instead of `title`)
 * @param {React.ReactNode} [message]
 * @param {string} [messageHtml] - message containing markup from translations (instead of `message`)
 * @param {React.ReactNode} [children] - buttons and anything below the message
 */
const MessageModal = ({
  show,
  onClose,
  icon: Icon,
  title,
  titleHtml,
  message,
  messageHtml,
  children,
}) => {
  const hasMessage = Boolean(message || messageHtml);

  return (
    <InfoModal show={show} onClose={onClose} paddingBody="tw:pt-0 tw:-mt-8 tw:mb-8 tw:mx-8" modalSize="tw:max-w-xl">
      <div className="tw:max-h-[70vh]">
        {Icon ? (
          <div className="tw:flex tw:justify-center">
            <Icon color={ICON_COLOR} size={ICON_SIZE} />
          </div>
        ) : null}

        {titleHtml ? (
          <p
            className="tw:text-center tw:mt-4 tw:mb-0 tw:!text-[18px] tw:!text-[#212529]"
            dangerouslySetInnerHTML={{ __html: titleHtml }}
          />
        ) : (
          <p className="tw:text-center tw:mt-4 tw:mb-0 tw:!text-[18px] tw:!text-[#212529]">{title}</p>
        )}

        {messageHtml ? (
          <p className="tw:text-center tw:mt-2 tw:!text-[#7C7B7B]" dangerouslySetInnerHTML={{ __html: messageHtml }} />
        ) : hasMessage ? (
          <div className="tw:text-center tw:mt-2 tw:!text-[#7C7B7B]">{message}</div>
        ) : null}

        {/* Same gap below the title whether or not there is a message. */}
        {children ? <div className={hasMessage ? "" : "tw:mt-6"}>{children}</div> : null}
      </div>
    </InfoModal>
  );
};

export default MessageModal;
